/* Based on 
 * - EGM Mathematical Finance class by Enrique Garcia M. <egarcia@egm.co>
 * - A Guide to the PMT, FV, IPMT and PPMT Functions by Kevin (aka MWVisa1)
 */

var ExcelFormulas = {

    PVIF: function (rate, nper) {
        return Math.pow(1 + rate, nper);
    },

    FVIFA: function (rate, nper) {
        return rate == 0 ? nper : (this.PVIF(rate, nper) - 1) / rate;
    },

    PMT: function (rate, nper, pv, fv, type) {
        if (!fv) fv = 0;
        if (!type) type = 0;

        if (rate == 0) return -(pv + fv) / nper;

        var pvif = Math.pow(1 + rate, nper);
        var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

        if (type == 1) {
            pmt /= (1 + rate);
        };

        return pmt;
    },

    IPMT: function (pv, pmt, rate, per) {
        var tmp = Math.pow(1 + rate, per);
        return 0 - (pv * tmp * rate + pmt * (tmp - 1));
    },

    PPMT: function (rate, per, nper, pv, fv, type) {
        if (per < 1 || (per >= nper + 1)) return null;
        var pmt = this.PMT(rate, nper, pv, fv, type);
        var ipmt = this.IPMT(pv, pmt, rate, per - 1);
        return pmt - ipmt;
    },

    DaysBetween: function (date1, date2) {
        var oneDay = 24 * 60 * 60 * 1000;
        return Math.round(Math.abs((date1.getTime() - date2.getTime()) / oneDay));
    },

    // Change Date and Flow to date and value fields you use
    XNPV: function (rate, values) {
        var xnpv = 0.0;
        var firstDate = new Date(values[0].Date);
        for (var key in values) {
            var tmp = values[key];
            var value = tmp.Flow;
            var date = new Date(tmp.Date);
            xnpv += value / Math.pow(1 + rate, this.DaysBetween(firstDate, date) / 365);
        };
        return xnpv;
    },

    XIRR: function (values, guess) {
        if (!guess) guess = 0.1;

        var x1 = 0.0;
        var x2 = guess;
        var f1 = this.XNPV(x1, values);
        var f2 = this.XNPV(x2, values);

        for (var i = 0; i < 100; i++) {
            if ((f1 * f2) < 0.0) break;
            if (Math.abs(f1) < Math.abs(f2)) {
                f1 = this.XNPV(x1 += 1.6 * (x1 - x2), values);
            }
            else {
                f2 = this.XNPV(x2 += 1.6 * (x2 - x1), values);
            }
        };

        if ((f1 * f2) > 0.0) return null;

        var f = this.XNPV(x1, values);
        if (f < 0.0) {
            var rtb = x1;
            var dx = x2 - x1;
        }
        else {
            var rtb = x2;
            var dx = x1 - x2;
        };

        for (var i = 0; i < 100; i++) {
            dx *= 0.5;
            var x_mid = rtb + dx;
            var f_mid = this.XNPV(x_mid, values);
            if (f_mid <= 0.0) rtb = x_mid;
            if ((Math.abs(f_mid) < 1.0e-6) || (Math.abs(dx) < 1.0e-6)) return x_mid;
        };

        return null;
    }

};


const CalculatorInvestitie = () => {

    if (jQuery('.calculator-investitii').length === 0) return;

    var calculatorValues = {
        investitiaInitiala: getUrlParameter('investitiaInitiala') ? parseInt(getUrlParameter('investitiaInitiala')) : 10000,
        investitiaLunara: getUrlParameter('investitiaLunara') ? parseInt(getUrlParameter('investitiaLunara')) : 100,
        perioada: getUrlParameter('perioada') ? parseInt(getUrlParameter('perioada')) : 5,
        randament: getUrlParameter('randament') ? parseInt(getUrlParameter('randament')) : 15,
        scop: getUrlParameter('scop') ? parseInt(getUrlParameter('scop')) : 1000000,
    };

    // Set the initial values
    jQuery('.calculator-investitie input#investitie-initiala').val(calculatorValues.investitiaInitiala);
    jQuery('.calculator-investitie input#contributie-lunara').val(calculatorValues.investitiaLunara);
    jQuery('.calculator-investitie input#perioada').val(calculatorValues.perioada);
    jQuery('.calculator-investitie input#randament').val(calculatorValues.randament);
    jQuery('.calculator-investitie input#scop').val(calculatorValues.scop);


    var calculatorType = jQuery('.calculator-investitie').attr('data-type');

    // If the calculatorType is found in the URL parameters, use that instead
    if (getUrlParameter('calculatorType')) {
        calculatorType = getUrlParameter('calculatorType');

        // console.log({ calculatorType });
        setTimeout(() => {
            jQuery('.calculator-investitie-tabs li[data-type="' + calculatorType + '"]').trigger('click');
        }, 150);
    }

    const calculatorTypes = ['castig', 'milionar', 'pensie'];

    if (calculatorTypes.indexOf(calculatorType) == -1) {
        console.error('Calculator type not found');
        calculatorType = 'castig';
    }

    // Initiate the calculator tabs
    jQuery('.calculator-investitie-tabs li').on('click', function () {
        jQuery('.calculator-investitie-tabs li').removeClass('active');
        jQuery(this).addClass('active');

        calculatorType = jQuery(this).attr('data-type');

        insertParam('calculatorType', calculatorType);

        if (calculatorTypes.indexOf(calculatorType) == -1) {
            console.error('Calculator type not found');
            calculatorType = 'castig';
        }

        jQuery('.calculator-investitie').attr('data-type', calculatorType);

        if (calculatorType == 'castig') {
            calculatorValues.perioada = 5;
            calculatorValues.investitiaLunara = 100;
            jQuery('.calculator-investitie input#perioada').val(calculatorValues.perioada);
            jQuery('.calculator-investitie input#contributie-lunara').val(calculatorValues.investitiaLunara);
        }

        if (calculatorType == 'milionar') {
            calculatorValues.perioada = 15;
            calculatorValues.investitiaLunara = 100;
            jQuery('.calculator-investitie input#perioada').val(calculatorValues.perioada);
            jQuery('.calculator-investitie input#contributie-lunara').val(calculatorValues.investitiaLunara);
        }
        if (calculatorType == 'pensie') {
            calculatorValues.perioada = 30;
            jQuery('.calculator-investitie input#perioada').val(calculatorValues.perioada);
        }

        showHideFields();
        calculateRates();
    });

    function showHideFields() {

        const fields = ['investitie-initiala', 'contributie-lunara', 'perioada', 'randament', 'scop-pensie'];

        // If we have the castig calculator, show all the fields
        if (calculatorType == 'castig') {
            fields.forEach(function (field) {
                jQuery('#' + field).show();
                jQuery('.calculator-investitie input#perioada').removeAttr('disabled');
                jQuery('.calculator-investitie #contributie-lunara').removeAttr('disabled');
            });

            // Show the scop-pensie field
            jQuery('.calculator-investitie #scop-pensie').parents('.field-line').addClass('hidden');
        }

        // If we have the milionar calculator, disable the perioada field
        if (calculatorType == 'milionar') {
            jQuery('.calculator-investitie #perioada').attr('disabled', 'disabled');
            jQuery('.calculator-investitie #contributie-lunara').removeAttr('disabled');
            jQuery('.calculator-investitie #scop-pensie').parents('.field-line').addClass('hidden');
        }


        if (calculatorType == 'pensie') {
            jQuery('.calculator-investitie #contributie-lunara').attr('disabled', 'disabled');
            jQuery('.calculator-investitie input#perioada').removeAttr('disabled');

            // Show the scop-pensie field
            jQuery('.calculator-investitie #scop-pensie').parents('.field-line').removeClass('hidden');
        }

    }


    function calculateRates() {

        // Create the calculation for the amount of months
        var calculationsArray = [];

        if (calculatorType == 'castig') {
            // Create the calculation for the amount of months
            for (var i = 0; i < calculatorValues.perioada * 12; i++) {

                let balanta = 0;
                if (i == 0) {
                    balanta = calculatorValues.investitiaInitiala;
                } else {
                    balanta = calculationsArray[i - 1].sold;
                }


                let dobandaLunara = calculatorValues.randament / 12 * balanta / 100;
                let balantaTotala = balanta + dobandaLunara;
                let sold = balantaTotala + calculatorValues.investitiaLunara;
                let dobandaTotala = i == 0 ? dobandaLunara : calculationsArray[i - 1].dobandaTotala + dobandaLunara;
                let investitiaTotala = i == 0 ? calculatorValues.investitiaInitiala + calculatorValues.investitiaLunara : calculationsArray[i - 1].investitiaTotala + calculatorValues.investitiaLunara;
                let contributiiLunare = i == 0 ? calculatorValues.investitiaLunara : calculationsArray[i - 1].contributiiLunare + calculatorValues.investitiaLunara;

                calculationsArray.push({
                    balanta: balanta,
                    dobandaLunara: dobandaLunara,
                    balantaTotala: balantaTotala,
                    sold: sold,
                    dobandaTotala: dobandaTotala,
                    investitiaTotala: investitiaTotala,
                    contributiiLunare: contributiiLunare
                });
            }
        }

        if (calculatorType == 'milionar') {
            // We have to calculate the perioada in months until we reach one million for the sold value
            var perioada = 0;
            var sold = 0;
            var dobandaTotala = 0;
            var investitiaTotala = 0;
            var contributiiLunare = 0;

            while (sold < 1000000) {
                let balanta = 0;
                if (perioada == 0) {
                    balanta = calculatorValues.investitiaInitiala;
                } else {
                    balanta = calculationsArray[perioada - 1].sold;
                }

                let dobandaLunara = calculatorValues.randament / 12 * balanta / 100;
                let balantaTotala = balanta + dobandaLunara;
                sold = balantaTotala + calculatorValues.investitiaLunara;
                dobandaTotala = perioada == 0 ? dobandaLunara : calculationsArray[perioada - 1].dobandaTotala + dobandaLunara;
                investitiaTotala = perioada == 0 ? calculatorValues.investitiaInitiala + calculatorValues.investitiaLunara : calculationsArray[perioada - 1].investitiaTotala + calculatorValues.investitiaLunara;
                contributiiLunare = perioada == 0 ? calculatorValues.investitiaLunara : calculationsArray[perioada - 1].contributiiLunare + calculatorValues.investitiaLunara;

                calculationsArray.push({
                    balanta: balanta,
                    dobandaLunara: dobandaLunara,
                    balantaTotala: balantaTotala,
                    sold: sold,
                    dobandaTotala: dobandaTotala,
                    investitiaTotala: investitiaTotala,
                    contributiiLunare: contributiiLunare
                });

                perioada++;
            }

            // Set the perioada value
            calculatorValues.perioada = (perioada / 12).toFixed(2);
            jQuery('.calculator-investitie input#perioada').val(calculatorValues.perioada);
        }

        if (calculatorType == 'pensie') {

            // In this case we have the goal of reaching a certain amount of money for the sold value (calculatorValues.scop) and we have to calculate how much we need to invest each month to reach that goal in the given time (calculatorValues.perioada)

            calculatorValues.investitiaLunara = -ExcelFormulas.PMT(calculatorValues.randament / 12 / 100, calculatorValues.perioada * 12, -calculatorValues.investitiaInitiala, calculatorValues.scop);
            jQuery('.calculator-investitie input#contributie-lunara').val(calculatorValues.investitiaLunara.toFixed(2));

            // Create the calculation for the amount of months
            for (var i = 0; i < calculatorValues.perioada * 12; i++) {

                let balanta = 0;
                if (i == 0) {
                    balanta = calculatorValues.investitiaInitiala;
                } else {
                    balanta = calculationsArray[i - 1].sold;
                }

                let dobandaLunara = calculatorValues.randament / 12 * balanta / 100;
                let balantaTotala = balanta + dobandaLunara;
                let sold = balantaTotala + calculatorValues.investitiaLunara;
                let dobandaTotala = i == 0 ? dobandaLunara : calculationsArray[i - 1].dobandaTotala + dobandaLunara;
                let investitiaTotala = i == 0 ? calculatorValues.investitiaInitiala + calculatorValues.investitiaLunara : calculationsArray[i - 1].investitiaTotala + calculatorValues.investitiaLunara;
                let contributiiLunare = i == 0 ? calculatorValues.investitiaLunara : calculationsArray[i - 1].contributiiLunare + calculatorValues.investitiaLunara;

                calculationsArray.push({
                    balanta: balanta,
                    dobandaLunara: dobandaLunara,
                    balantaTotala: balantaTotala,
                    sold: sold,
                    dobandaTotala: dobandaTotala,
                    investitiaTotala: investitiaTotala,
                    contributiiLunare: contributiiLunare
                });

                if (sold >= calculatorValues.scop) {
                    break;
                }
            }


        }

        // console.log(calculationsArray);
        // generateLines(calculationsArray);
        generateChart(calculationsArray);


        // Change the results text in the calculator
        if (calculatorType == 'milionar') {
            // INVESTITIE_INITIALA -> ${calculatorValues.investitiaInitiala}
            // RANDAMENT -> ${calculatorValues.randament}
            // INVESTITIE_LUNARA -> ${calculatorValues.investitiaLunara}
            var text = faguraData.investor_confirmation_text;

            text = text.replace('INVESTITIE_INITIALA', calculatorValues.investitiaInitiala.toFixed(0));
            text = text.replace('RANDAMENT', calculatorValues.randament.toFixed(2));
            text = text.replace('INVESTITIE_LUNARA', calculatorValues.investitiaLunara.toFixed(2));
            text = text.replace('PERIOADA', calculatorValues.perioada.toFixed(0));
            text = text.replace('SCOP', calculatorValues.scop);

            console.log({ text })

            jQuery('#calculator-results-message').html(text);

        } else if (calculatorType == 'pensie') {

            var text = faguraData.investor_retirement_text;

            // PERIOADA -> ${calculatorValues.perioada}
            // SCOP -> ${calculatorValues.scop}
            // INVESTITIE_LUNARA -> ${calculatorValues.investitiaLunara}
            // INVESTITIE_INITIALA -> ${calculatorValues.investitiaInitiala}
            // RANDAMENT -> ${calculatorValues.randament}

            text = text.replace('PERIOADA', calculatorValues.perioada.toFixed(0));
            text = text.replace('SCOP', calculatorValues.scop);
            text = text.replace('RANDAMENT', calculatorValues.randament.toFixed(2));
            text = text.replace('INVESTITIE_LUNARA', calculatorValues.investitiaLunara.toFixed(2));
            text = text.replace('INVESTITIE_INITIALA', calculatorValues.investitiaInitiala.toFixed(0));

            jQuery('#calculator-results-message').html(text);
        } else if (calculatorType == 'castig') {
            text = faguraData.investor_benefit_text;
            jQuery('#calculator-results-message').html(text);
        }


        // Find the .total-investitie div and add the total investitie
        jQuery('.total-sold').text(calculationsArray[calculationsArray.length - 1].sold.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));

        jQuery('.total-dobanda').text(calculationsArray[calculationsArray.length - 1].dobandaTotala.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        jQuery('.total-investitie').text(calculationsArray[calculationsArray.length - 1].investitiaTotala.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        jQuery('.total-contributii').text(calculationsArray[calculationsArray.length - 1].contributiiLunare.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        jQuery('.perioada-investitii-counter').text(calculatorValues.perioada);
    }

    function generateLines(calculationsArray) {
        // Clean the .investitii-table div
        jQuery('.investitii-table').html('');

        // Add the final information before the table
        jQuery('.investitii-table').append('Sold in ' + calculatorValues.perioada + ' ' + faguraData.ani + ': ' + calculationsArray[calculationsArray.length - 1].sold.toFixed(2) + ' euro &nbsp;&nbsp;&nbsp;');

        jQuery('.investitii-table').append('Investitie totala in ' + calculatorValues.perioada + ' ' + faguraData.ani + ': ' + (calculationsArray[calculationsArray.length - 1].investitiaTotala).toFixed(2) + ' euro &nbsp;&nbsp;&nbsp;');

        // Add the dobanda totala
        jQuery('.investitii-table').append('Dobanda totala: ' + calculationsArray[calculationsArray.length - 1].dobandaTotala.toFixed(2) + ' euro');

        // Iterate through the calculationsArray and generate the div lines
        for (var i = 0; i < calculationsArray.length; i++) {
            var line = '<div class="investitii-table-line make-flex">';
            line += '<div class="investitii-table-line-column make-inline-flex text-center make-flex-1">' + (i + 1) + '</div>';
            line += '<div class="investitii-table-line-column make-inline-flex text-center make-flex-1">' + calculationsArray[i].balanta.toFixed(2) + '</div>';
            line += '<div class="investitii-table-line-column make-inline-flex text-center make-flex-1">' + calculationsArray[i].dobandaLunara.toFixed(2) + '</div>';
            line += '<div class="investitii-table-line-column make-inline-flex text-center make-flex-1">' + calculationsArray[i].balantaTotala.toFixed(2) + '</div>';
            line += '<div class="investitii-table-line-column make-inline-flex text-center make-flex-1">' + calculationsArray[i].sold.toFixed(2) + '</div>';
            line += '<div class="investitii-table-line-column make-inline-flex text-center make-flex-1">' + calculationsArray[i].dobandaTotala.toFixed(2) + '</div>';
            line += '</div>';

            jQuery('.investitii-table').append(line);
        }

    }

    // Add event listeners to the inputs to update the values

    var investitiaInitiala = document.getElementById('investitie-initiala');
    var contributiaLunara = document.getElementById('contributie-lunara');
    var perioada = document.getElementById('perioada');
    var randament = document.getElementById('randament');
    var scopPensie = document.getElementById('scop-pensie');

    investitiaInitiala.addEventListener('input', function () {
        calculatorValues.investitiaInitiala = parseFloat(this.value) > 0 ? parseFloat(this.value) : 0;
        this.value = calculatorValues.investitiaInitiala;
        calculateRates();

        // Add arg to URL
        insertParam('investitiaInitiala', calculatorValues.investitiaInitiala);
    });

    contributiaLunara.addEventListener('input', function () {
        calculatorValues.investitiaLunara = parseFloat(this.value) > 0 ? parseFloat(this.value) : 0;
        this.value = calculatorValues.investitiaLunara;
        calculateRates();

        insertParam('investitiaLunara', calculatorValues.investitiaLunara);
    });

    perioada.addEventListener('input', function () {
        calculatorValues.perioada = parseFloat(this.value) > 0 ? parseFloat(this.value) : 0;
        this.value = calculatorValues.perioada;
        calculateRates();

        insertParam('perioada', calculatorValues.perioada);
    });

    randament.addEventListener('input', function () {
        calculatorValues.randament = parseFloat(this.value) > 0 ? parseFloat(this.value) : 0;
        this.value = calculatorValues.randament;
        calculateRates();

        insertParam('randament', calculatorValues.randament);
    });

    scopPensie.addEventListener('input', function () {
        calculatorValues.scop = parseFloat(this.value) > 0 ? parseFloat(this.value) : 0;
        this.value = calculatorValues.scop;
        calculateRates();

        // Add arg to URL
        insertParam('scop', calculatorValues.scop);
    });


    calculateRates();

    function generateChart(calculationsArray) {

        var chartData = [[0, calculationsArray[0].balanta]];

        // Go through the calculationsArray and generate the chart data
        for (var i = 0; i < calculationsArray.length; i++) {

            // Create the date for today
            var date = new Date();
            date.setMonth(date.getMonth() + i);

            // Get the date in milliseconds
            date = date.getTime();

            chartData.push([(i + 1) / 12, parseInt(calculationsArray[i].sold)]);
        }

        var cyears = parseInt(calculatorValues.perioada);
        var xmax = cyears;
        var ymax = calculationsArray[calculationsArray.length - 1].sold + 2000;

        // Go through the calculationsArray and generate the chart data for dobandaTotala
        var chartData2 = [[0, 0]];
        for (var i = 0; i < calculationsArray.length; i++) {
            chartData2.push([(i + 1) / 12, parseInt(calculationsArray[i].dobandaTotala)]);
        }
        // Go through the calculationsArray and generate the chart data for contributiaTotala
        var chartData3 = [[0, 0]];
        for (var i = 0; i < calculationsArray.length; i++) {
            chartData3.push([(i + 1) / 12, parseInt(calculationsArray[i].contributiiLunare)]);
        }

        // Last year
        var lastYear = (calculationsArray.length - 12) / 12;
        var finishYear = calculationsArray.length / 12;


        jQuery('#cchartdiv').highcharts({
            chart: {
                type: 'area',
                plotBorderWidth: 0,
                backgroundColor: 'transparent',
                spacingBottom: 15,
                spacingTop: 10,
                spacingLeft: 10,
                spacingRight: 10,
                height: jQuery(window).outerWidth() > 768 ? 310 : 220,
            },
            title: { text: '' },
            xAxis: {
                min: 0,
                max: xmax,
                title: { text: '' },
                gridLineWidth: 1,
                gridLineColor: '#E5E7EB',
                labels: {
                    formatter: function () {
                        if (cyears <= 1) {
                            return this.value + ' ' + faguraData.luni;
                        } else {
                            return this.value + ' ' + faguraData.ani;
                        }
                        // // Start with current year for this.value = 0 and add this.value years
                        // var date = new Date();
                        // date.setFullYear(date.getFullYear() + this.value);

                        // // Get the year
                        // var year = date.getFullYear();

                        // // Return the year
                        // return year;
                    }
                },
                // plotBands: [{ // Highlight the last year
                //     // className: 'futureYears',
                //     from: lastYear,
                //     to: finishYear,
                //     color: 'rgba(35,35,35,0.25)',
                //     zIndex: 5,
                // }]
            },
            yAxis: {
                min: 0,
                // max: ymax,
                title: { text: '' },
                gridLineWidth: 0,
                gridLineColor: '#F3F4F6',
                labels: {
                    zIndex: 60,
                    formatter: function () {
                        let tempVal = this.value;
                        if (this.value > 999) tempVal = (this.value / 1000).toFixed(1) + 'K';
                        if (this.value > 999999) tempVal = (this.value / 1000000).toFixed(1) + 'M';
                        if (tempVal == 0) return '';

                        // Separate the thousands by comma
                        tempVal = tempVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        return '€' + tempVal;
                    },
                },
            },
            plotOptions: {
                area: {
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2,
                    },
                    lineWidth: 1,
                    states: {
                        hover: {
                            lineWidth: 2
                        }
                    },
                    threshold: null,
                    fillOpacity: 1
                }
            },
            tooltip: {
                headerFormat: '',
                shared: true,
                borderColor: '#F3F4F6',
                formatter: function () {

                    let monthCount = this.x * 12;

                    // Starting with today, add this.x months and get the year and month from the date
                    var date = new Date();
                    date.setMonth(date.getMonth() + monthCount);
                    var year = date.getFullYear();
                    var month = date.getMonth();

                    const monthNames = faguraData.monthNames;


                    const dateHtml = faguraData.in + ' <strong>' + monthNames[month] + ' ' + year + '</strong><br>';

                    // Get the value of the current series
                    var value = this.points[0].y;
                    var value2 = this.points[1].y;
                    var value3 = this.points[2].y;

                    // Separate the thousands by comma
                    value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    value2 = value2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    value3 = value3.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    // Get the name of the current series
                    var name = this.points[0].series.name;
                    var name2 = this.points[1].series.name;
                    var name3 = this.points[2].series.name;

                    // Return the HTML
                    return dateHtml + '<strong style="color:#1460A7;font-weight:bold;">' + name + '</strong>: <strong>€' + value + '</strong>' + '<br>' + '<strong style="color:#F7941E;font-weight:bold;">' + name2 + '</strong>: <strong>€' + value2 + '</strong>' + '<br>' + '<strong style="color:#C16A01;font-weight:bold;">' + name3 + '</strong>: <strong>€' + value3 + '</strong>'

                },
            },
            legend: { enabled: false },
            series: [
                {
                    type: 'area',
                    name: faguraData.soldText,
                    data: chartData,
                    color: '#733cc4',
                },
                {
                    type: 'area',
                    name: faguraData.dobandaAcumulata,
                    data: chartData2,
                    color: '#ffcd00',
                    opacity: 1,
                    lineColor: 'transparent'
                },
                {
                    type: 'area',
                    name: faguraData.contributiiLunare,
                    data: chartData3,
                    color: '#d19600',
                    opacity: 1,
                    lineColor: 'transparent'
                }
            ]
        });

    }



}

CalculatorInvestitie();